module.exports = __webpack_public_path__ + "img/wow.2a4bafa3.png";